import React from 'react';

interface Step1NameProps {
  value: string;
  onChange: (value: string) => void;
}

export const Step1Name: React.FC<Step1NameProps> = ({ value, onChange }) => {
  return (
    <div className="space-y-4">
      <label className="block">
        <span className="text-lg font-semibold text-gray-800 mb-2 block">
          Nom de l'alerte
        </span>
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Ex: Pull Ralph Lauren"
          className="w-full px-4 py-3 text-lg border-2 border-gray-300 rounded-xl focus:ring-2 focus:ring-cyan-500 focus:border-transparent"
          autoFocus
        />
      </label>
      <p className="text-sm text-gray-500">
        Le nom n'affecte pas la recherche, c'est juste pour vous y retrouver.
      </p>
    </div>
  );
};
